import Vue from 'vue'
import Vuex from 'vuex'
import {
  removeToken
} from "../token";

Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    isLogIn: JSON.parse(localStorage.getItem('saasIsLogIn')) || false,
    merchantNo: localStorage.getItem('merchantNo') || '',
    isSomeBind: JSON.parse(localStorage.getItem('isSomeBind')) || false,
    submitFlag: false,
    selectBank: sessionStorage.getItem('selectBank') === 'true',
    changeBank: sessionStorage.getItem('changeBank') === 'true',
    cashBankCard: sessionStorage.getItem('cashBankCard') && JSON.parse(sessionStorage.getItem('cashBankCard')) || {},
    applyMax: +sessionStorage.getItem('applyMax') || 1000,
    applyMin: +sessionStorage.getItem('applyMin') || 100,
    applyStep: +sessionStorage.getItem('applyStep') || 100,
    cashMoney: sessionStorage.getItem('cashMoney') || 0.00,
    cashMerchantId: sessionStorage.getItem('cashMerchantId') || 0,
    isJump: false,
    activeCardDetail: sessionStorage.getItem('activeCardDetail') && JSON.parse(sessionStorage.getItem('activeCardDetail')) || {},
    showNeedBind: sessionStorage.getItem('showNeedBind') || false, //支付宝、银行卡都未绑定，需要绑定弹窗
    aliAccount: sessionStorage.getItem('aliAccount') || '', //支付宝账号
    //merchantNo: sessionStorage.getItem('merchantNo') || '', //商户编号
    orderNo: sessionStorage.getItem('orderNo') || '', //合同编号
    customerNo: sessionStorage.getItem('customerNo') || '', //用户编号
    isCase: sessionStorage.getItem('isCase') || '', // 做缓
    idCard: sessionStorage.getItem('idCard') || '', //身份id
    name: sessionStorage.getItem('name') || '',
    dailyPayAuditText: null,
    alipayData: {}
  },
  getters: {

  },
  mutations: {
    SET_MERCHANT_NO: (state, value) => { //设置企业merchantNo
      state.merchantNo = value;
      localStorage.setItem('merchantNo', value);
    },
    SET_LOG_IN_STATIC: (state, statue) => {
      state.isLogIn = statue; //设置是否登录
      if (statue === false) {
        removeToken()
      }
      localStorage.setItem('saasIsLogIn', statue);
    },
    SET_SOME_BIND_STATIC: (state, statue) => {
      state.isSomeBind = statue; //设置是否登录
      localStorage.setItem('isSomeBind', statue);
    },
    TOGGLE_SUBMIT_FLAG: (state, statue) => {
      state.submitFlag = statue;
    },
    SET_ACTIVE_CARD_DETAIL: (state, value) => {
      state.activeCardDetail = value;
      sessionStorage.setItem('activeCardDetail', JSON.stringify(value));
    },
    SET_APPLY_MIN: (state, value) => { //预支最小金额
      state.applyMin = value;
      sessionStorage.setItem('applyMin', value);
    },
    SET_APPLY_MAX: (state, value) => { //预支最大金额
      state.applyMax = value;
      sessionStorage.setItem('applyMax', value);
    },
    SET_APPLY_STEP: (state, value) => { //预支步骤
      state.applyStep = value;
      sessionStorage.setItem('applyStep', value);
    },
    SET_CASH_MONEY: (state, value) => { //设置提现金额
      state.cashMoney = value;
      sessionStorage.setItem('cashMoney', value);
    },
    SET_CASH_MERCHANT_ID: (state, value) => { //设置商户Id
      state.cashMerchantId = value;
      sessionStorage.setItem('cashMerchantId', value);
    },
    SET_SHOW_NEED_BIND: (state, value) => { //设置都未绑定显示弹窗
      state.showNeedBind = value;
      value ? sessionStorage.setItem('showNeedBind', value) : sessionStorage.removeItem('showNeedBind');
    },
    SET_ALI_ACCOUNT: (state, value) => {
      state.aliAccount = value;
      sessionStorage.setItem('aliAccount', value);
    },
    // SET_MERCHANT_NO: (state, value) => { //商户编号
    //   state.merchantNo = value;
    //   sessionStorage.setItem('merchantNo', value);
    //   // 和上面的方法冲突，由于不知道会不会有人直接locastorage取所以兼容一哈
    //   localStorage.setItem('merchantNo', value);
    // },
    SET_ORDER_NO: (state, value) => { //合同编号
      state.orderNo = value;
      sessionStorage.setItem('orderNo', value);
    },
    SET_CUSTOMER_NO: (state, value) => { //用户编号
      state.customerNo = value;
      sessionStorage.setItem('customerNo', value);
    },
    SET_CASE: (state, value) => { //名字
      state.isCase = value;
      sessionStorage.setItem('isCase', value);
    },
    SET_CARD_ID: (state, value) => { //身份ID
      state.idCard = value;
      sessionStorage.setItem('idCard', value);
    },
    SET_NAME: (state, value) => { //名字
      state.name = value;
      sessionStorage.setItem('name', value);
    },
    SET_DailyPayAuditText: (state, value) => { //名字
      state.dailyPayAuditText = value;
    },
    SET_ALIPAYDATA: (state, value = {}) => {
      state.alipayData = value;
    }
  },
  actions: {

  }
})
